import { ContentColumn } from "@components/layout/Content";
import { ContentLoader } from "@repo/ui/core";
import type { ComponentProps } from "react";

export { ContentLoader };

export function PageLoadingOverlay(props: ComponentProps<typeof ContentLoader>) {
  return (
    <ContentColumn pos="relative" w="100%">
      <ContentLoader {...props} />
    </ContentColumn>
  );
}
